// 購入変更時に、自身のチケットの座席種別が選択した列車に含まれているか確認する
export const isExistMySeatAttribute = (mySeatAttribute, trainInfo) => {
  switch (mySeatAttribute) {
    // 一般席
    case "1":
      return (
        trainInfo.common_vacant_seat_count > 0 &&
        trainInfo.common_vacant_seat_count != 999
      );
    // 前展望席
    case "2":
      return (
        trainInfo.foreground_vacant_seat_count > 0 &&
        trainInfo.foreground_vacant_seat_count != 999
      );
    // 後展望席
    case "3":
      return (
        trainInfo.background_vacant_seat_count > 0 &&
        trainInfo.background_vacant_seat_count != 999
      );
    // サルーン席
    default:
      return (
        trainInfo.saloon_vacant_seat_count > 0 &&
        trainInfo.saloon_vacant_seat_count != 999
      );
  }
};
